export interface IPaperclipConfig {
    message: string,
    url: string,
    linktext: string,
}

export interface IPaperclipWidgetState {
    isCollapsed: boolean;
    config: IPaperclipConfig,
}

export class PaperclipWidgetState implements IPaperclipWidgetState {
    isCollapsed = false;
    config: IPaperclipConfig = {
        message: "",
        url: "",
        linktext: "",
    };

    constructor() {
        // Load the collapsed state from local storage
        this.loadWidgetCollapsedState();

        // when the window is less than 910 points,
        // the widget is collapsed by default.
        if (window.innerWidth <= 910) {
          this.isCollapsed = true;
        }
    }

    loadWidgetCollapsedState() {
        const state = localStorage.getItem("paperclip-widget-isCollapsed");

        // If the state is not null, parse it and set the state
        if (state) {
          const parsedState = JSON.parse(state) as boolean;
          this.isCollapsed = parsedState;
        }
    }
}
